import { PulseCTA } from "./GoldButton";

export const StickyCTA = () => (
  <div className="fixed inset-x-0 bottom-0 z-50 border-t border-[rgba(232,184,74,0.3)] bg-[#0a0a0a]/90 px-4 pb-[calc(12px+env(safe-area-inset-bottom))] pt-3 backdrop-blur-md md:hidden" data-testid="sticky-cta-bar">
    <PulseCTA size="md" className="w-full" data-testid="sticky-cta-button" />
  </div>
);
